<template>
    <div>
        <Breadcrumb section-name="Employee" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body" :class="{'data-loading': dataLoading}">
                    <div class="fixed-card-height">
                        <div class="row">
                            <div class="col-sm-5">
                                <div class="card border-top border-0 border-4 border-primary">
                                    <div class="card-body p-4">
                                        <div class="card-title d-flex align-items-center">
                                            <h5 class="mb-0 text-primary">System Information</h5>
                                        </div>
                                        <hr>
                                        <div class="row g-3">
                                            <div class="col-md-6 form-group d-flex align-items-center">
                                                <label class="form-label">Employee Type:</label>
                                                <div class="text-capitalize">{{ addEditParam.type }}</div>
                                            </div>
                                            <div class="col-md-6 form-group d-flex align-items-center">
                                                <label class="form-label">Project Name:</label>
                                                <div class="text-capitalize">{{ addEditParam.project_name }}</div>
                                            </div>
                                            <div class="col-md-6 form-group d-flex align-items-center">
                                                <label class="form-label">ID Number:</label>
                                                <div>{{addEditParam.id_number}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card border-top border-0 border-4 border-primary">
                                    <div class="card-body p-4">
                                        <div class="card-title d-flex align-items-center">
                                            <h5 class="mb-0 text-primary">Contact Information</h5>
                                        </div>
                                        <hr>
                                        <div class="row g-3">
                                            <div class="col-md-6 form-group d-flex align-items-center ">
                                                <label class="form-label">Active Mobile Number:</label>
                                                <div>{{addEditParam.mobile_number}}</div>
                                            </div>
                                            <div class="col-md-6 form-group d-flex align-items-center">
                                                <label class="form-label">Family Mobile No:</label>
                                                <div>{{addEditParam.family_mobile_number}}</div>
                                            </div>
                                            <div class="col-md-6 form-group d-flex align-items-center">
                                                <label class="form-label">Whatsapp Number:</label>
                                                <div>{{addEditParam.whatsapp_number}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card border-top border-0 border-4 border-primary">
                                    <div class="card-body p-4">
                                        <div class="card-title d-flex align-items-center">
                                            <h5 class="mb-0 text-primary">Address Information</h5>
                                        </div>
                                        <hr>
                                        <div class="row g-3">
                                            <div class="col-md-12 form-group d-flex align-items-center">
                                                <label class="form-label">Present Address:</label>
                                                <div>{{addEditParam.present_address}}</div>
                                            </div>
                                            <div class="col-md-12 form-group d-flex align-items-center">
                                                <label class="form-label">Permanent Address:</label>
                                                <div>{{addEditParam.permanent_address}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-7">
                                <div class="card border-top border-0 border-4 border-primary">
                                    <div class="card-body p-4">
                                        <div class="card-title d-flex align-items-center justify-content-between">
                                            <h5 class="mb-0 text-primary">Personal Information</h5>
<!--                                            <a class="me-2 btn btn-option" href="javascript:void(0)" @click="downloadPdf">-->
<!--                                                <img v-if="!download[1].loading" class="pdf" width="16" height="16"/>-->
<!--                                                <span v-if="download[1].loading" class="spinner-border spinner-border-sm" role="status"-->
<!--                                                      aria-hidden="true"></span>-->
<!--                                            </a>-->
                                        </div>
                                        <hr>
                                        <div class="row g-3">
                                            <div class="col-md-12">
                                                <div class="row mb-4">
                                                    <div class="col-sm-3">
                                                        <template v-if="photo">
                                                            <div class="position-relative w-content">
                                                                <img class="avatar" :src="photo" alt="">
                                                            </div>
                                                        </template>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <div class="row">
                                                            <div class="col-sm-6">
                                                                <div class="mb-3 form-group d-flex align-items-center">
                                                                    <label class="form-label">Name:</label>
                                                                    <div>{{addEditParam.name}}</div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <div class="mb-3 form-group d-flex align-items-center">
                                                                    <label class="form-label">Father's Name:</label>
                                                                    <div>{{addEditParam.father_name}}</div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <div class="mb-3 form-group d-flex align-items-center">
                                                                    <label class="form-label">Mother's Name:</label>
                                                                    {{addEditParam.mother_name}}
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <div class="mb-3 form-group d-flex align-items-center">
                                                                    <label class="form-label">Spouse Name:</label>
                                                                    <div>{{addEditParam.spouse_name}}</div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <div class="mb-3 form-group d-flex align-items-center">
                                                                    <label class="form-label">Total Share:</label>
                                                                    <div>{{addEditParam.total_share}}</div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6">
                                                                <template v-if="signature">
                                                                    <div class="position-relative">
                                                                        <label class="form-label">Signature:</label>
                                                                        <img class="signature" :src="signature" alt="">
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Nationality:</label>
                                                <div>{{addEditParam.nationality}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">NID Number:</label>
                                                <div>{{addEditParam.nid_number}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">TIN Number:</label>
                                                <div class="text-capitalize">{{addEditParam.tin_number}}</div>
                                            </div>

                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Marital Status:</label>
                                                <div class="text-capitalize">{{addEditParam.marital_status}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Blood Group:</label>
                                                <div class="text-capitalize">{{addEditParam.blood_group}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Hobby:</label>
                                                <div>{{addEditParam.hobby}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Occupation:</label>
                                                <div>{{addEditParam.occupation}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Working Committee Member:</label>
                                                <div>{{addEditParam.working_committee_member === 0 ? 'No' : 'Yes'}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Purchase Committee Member:</label>
                                                <div>{{addEditParam.purchase_committee_member === 0 ? 'No' : 'Yes'}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Audit Committee Member:</label>
                                                <div>{{addEditParam.audit_committee_member === 0 ? 'No' : 'Yes'}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Project Committee Member :</label>
                                                <div>{{addEditParam.project_committee_member === 0 ? 'No' : 'Yes'}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Designation:</label>
                                                <div>{{addEditParam.designation_name}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">District:</label>
                                                <div>{{addEditParam.district_name}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Area:</label>
                                                <div>{{addEditParam.area_name}}</div>
                                            </div>
                                            <div class="col-md-4 form-group d-flex align-items-center">
                                                <label class="form-label">Investor Category:</label>
                                                <div>{{addEditParam.investor_category_name}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-end">
                        <router-link :to="{name: 'shareholder'}" type="button" class="btn btn-secondary me-2 btn-width" >Close</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumb from "../Common/Breadcrumb";
import ApiService from "../../Services/ApiService";
import ApiRoutes from "../../Services/ApiRoutes";
import DownloadService from "../../Services/DownloadService";
export default {
    components: {Breadcrumb},
    data() {
        return {
            breadCrumb: ['View'],
            loading: false,
            dataLoading: false,
            addEditParam: {},
            id: null,
            photo: null,
            signature: null,
            download: [
                {
                    icon: 'xls',
                    loading: false,
                    action: () => {
                        this.downloadFile('xls')
                    }
                },
                {
                    icon: 'pdf',
                    loading: false,
                    action: () => {
                        this.downloadFile('pdf')
                    }
                }
            ],
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.getSingle()
    },
    mounted () {

    },
    watch: {},
    methods: {
        downloadPdf: function () {
          //  DownloadService.download(ApiRoutes.EmployeeSingleExportPdf, this.download, this.addEditParam.name+'.pdf', 'pdf', {id: this.id})
        },
        getSingle: function () {
            this.dataLoading = true;
            ApiService.POST(ApiRoutes.ShareHolder + '/single', {id: this.id}, (res) => {
                this.dataLoading = false;
                if (parseInt(res.status) === 200) {
                    this.addEditParam = res.data
                    if (this.addEditParam.image_path) {
                        this.photo = this.addEditParam.image_path
                    }
                    if (this.addEditParam.signature_path) {
                        this.signature = this.addEditParam.signature_path
                    }
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.form-label{
    font-weight: bold;
    margin-right: 15px;
    margin-bottom: 0;
}
</style>
